package org.gstechnovos.jexonplastech

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import kotlinx.browser.document
import kotlinx.browser.window
import org.gstechnovos.jexonplastech.util.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.rememberBreakpoint
import org.jetbrains.compose.web.css.*


private const val COLOR_MODE_KEY = "site:colorMode"

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage(COLOR_MODE_KEY) ?: ColorMode.systemPreference

    ctx.stylesheet.registerStyleBase("html") {
        Modifier.scrollBehavior(ScrollBehavior.Smooth)
    }
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        var colorMode by ColorMode.currentState

        // Track the screen size globally
        val breakpoint by rememberBreakpoint()

        LaunchedEffect(Unit) {
            document.documentElement?.classList?.remove("preloader-active")
        }

        LaunchedEffect(colorMode) {
            colorMode = ColorMode.LIGHT

            // 2. Aggressively overwrite the browser's local cache so it forgets Dark Mode forever
            window.localStorage.setItem("kobweb-color-mode", "light")
            window.localStorage.setItem("site:colorMode", "light")
        }

        // Provide the breakpoint to the entire app!
        CompositionLocalProvider(LocalBreakpoint provides breakpoint) {
            Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
                content()
            }
        }
    }

}
